import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { useTheme } from '@mui/styles';

import '../../../components/BargraphHichart/Bargraph.scss';
import { Grid } from '@mui/material';

const BarGraphChatBot = (props: any) => {
	const theme: any = useTheme();
	const shouldShowTable = props?.type && props?.categories?.length;
	const options = {
		chart: {
			type: props?.type || 'column',
			plotBackgroundColor: theme.palette.background.light,
			backgroundColor: theme.palette.background.light,
			borderColor: theme.palette.background.light,
			plotShadow: false,
			className: 'highcharts-color-0',
			renderTo: 'container',
		},
		scrollbar: {
			enabled: true,
		},
		title: {
			style: {
				textTransform: 'capitalize',
				fontSize: '22px',
				fontWeight: 'bold',
				color: theme.palette.text.primary,
				fontFamily:
					"lato, BlinkMacSystemFont, 'Segoe UI', Loto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
			},
			text: props?.categories?.length ? props?.title : '',
		},
		credits: {
			enabled: false,
		},
		xAxis: {
			categories: props?.categories || [],
		},
		yAxis: {
			min: 0,
			title: {
				text: props?.yAxisName,
			},
		},
		plotOptions: {
			column: {
				pointPadding: 0.2,
				borderWidth: 0,
			},
		},
		series: [
			{
				name: props?.xAxisName || 'Data',
				data: props?.series.data || [],
			},
		],
		exporting: {
			showTable: shouldShowTable,
		},
		lang: {
			noData: props?.noDataMessage || 'There is no data in the graph ',
		},
		noData: {
			style: {
				fontWeight: 'bold',
				fontSize: '15px',
				color: theme.palette.text.primary,
			},
		},

		colors: props.colors || [
			'#6C63FF',
			'#00E9FA',
			'#FF9C7F',
			'#B14708',
			'#213142',
			'#FF2366',
			'#6697CC',
			'#FFD950',
			'#297373',
		],

		legend: {
			itemDistance: 5,
			itemMarginTop: 5,
			itemMarginBottom: 5,
			itemWidth: 150,
			style: {
				margin: 'auto',
				textAlign: 'center',
			},
			itemStyle: {
				textAlign: 'right',
				fontSize: '13px',
				fontFamily: 'Lato !important',
				color: theme.palette.text.primary,
				fontWeight: '400 !important',
			},
			itemHoverStyle: {
				color: '#707070',
			},
			itemHiddenStyle: {
				color: '#707070',
			},
			// @ts-ignore
		},
	};

	return (
		<Grid className='bargraph' bgcolor={theme.palette.background.light}>
			<HighchartsReact
				// id="pieId"
				highcharts={Highcharts}
				options={options}
			/>
		</Grid>
	);
};

export default BarGraphChatBot;
